import { useMemo } from "react";
import Model from "@tripian/model";
import useUser from "./useUser";

export const useGuestUserForSimplyCaribbean = (): boolean => {
  const { user } = useUser();

  return useMemo(() => {
    const isGuestUser = user?.userType === Model.USER_TYPE.GUEST;
    const isSimplyCaribbeanDomain =
      window.location.hostname.startsWith("simply-caribbean");

    return isGuestUser && isSimplyCaribbeanDomain;
  }, [user]);
};
